// extracted by mini-css-extract-plugin
module.exports = {"order-image-item__image":"OrderImageItem_order-image-item__image__wF934"};